import BaseType from "../BaseType";
import Guid from "../Guid";
import Enumeration from "./Enumeration";

export default class EnumerationResponseItem extends BaseType {
  EnumerationResponseHeaderId: string = Guid.Empty;
  EnumerationId: string = Guid.Empty;
  Enumeration: Enumeration | undefined;
}
